/**
 * Order status derived from tip + flag1 (planDvizhDeneg / oplatDvizhDenegApp).
 *
 * tip === '1' && flag1 === '0' → Новые
 * tip === '1' && flag1 === '1' → На оплате
 * tip === '0'                  → Оплаченные
 */

export const STATUSES = [
    { key: 'new', label: 'Новые', color: '#42a5f5', colort: '#fff', chipClass: 'chip-new' },
    { key: 'topay', label: 'На оплате', color: '#66bb6a', colort: '#fff', chipClass: 'chip-warning' },
    { key: 'paid', label: 'Оплаченные', color: '#d4e157', colort: '#000', chipClass: 'chip-success' },
];

export const DEFAULT_STATUSES = STATUSES.map((s) => s.key);

const VALID_STATUS_KEYS = new Set(DEFAULT_STATUSES);

/**
 * @param {object} item
 * @returns {{ key: string, label: string, color: string, colort: string, chipClass: string } | null}
 */
export function getStatus(item) {
    if (!item) return null;

    const tip = String(item.tip);
    const flag1 = String(item.flag1);

    if (tip === '1' && flag1 === '0') return STATUSES[0];
    if (tip === '1' && flag1 === '1') return STATUSES[1];
    if (tip === '0') return STATUSES[2];

    return null;
}

/** Label for UI; unknown tip/flag1 → «Неизвестный статус» */
export function getStatusLabel(item) {
    return getStatus(item)?.label ?? 'Неизвестный статус';
}

/** Status key for filtering, or null if unmatched */
export function getStatusKey(item) {
    return getStatus(item)?.key ?? null;
}

/** tip === 1 && flag1 === 0 — «Новые», можно удалять и редактировать */
export function isNewOrder(item) {
    return getStatusKey(item) === 'new';
}

function hasText(v) {
    return v != null && String(v).trim() !== '';
}

export function isCorrectedComment(text) {
    return hasText(text) && String(text).indexOf('Исправлено') !== -1;
}

/** Непустой kommentKontr и/или kommentKazna — есть замечание контролёра/казначея */
export function isRejected(item) {
    return hasText(item?.kommentKontr) || hasText(item?.kommentKazna);
}

/** Все непустые замечания помечены «Исправлено» */
export function isCorrected(item) {
    const notes = rejectionNotes(item);
    return notes.length > 0 && notes.every((n) => n.corrected);
}

/**
 * @param {object} item
 * @returns {{ label: string, text: string, vid: string, corrected: boolean }[]}
 */
export function rejectionNotes(item) {
    const notes = [];
    if (hasText(item?.kommentKontr)) {
        const text = String(item.kommentKontr).trim();
        notes.push({
            label: 'Контролёр',
            text,
            vid: 'kontr',
            corrected: isCorrectedComment(text),
        });
    }
    if (hasText(item?.kommentKazna)) {
        const text = String(item.kommentKazna).trim();
        notes.push({
            label: 'Казначей',
            text,
            vid: 'kazna',
            corrected: isCorrectedComment(text),
        });
    }
    return notes;
}

/**
 * Validate saved filter keys. Empty array = «Все».
 * Old vid-based values ('2','3','4') fail validation → caller should reset.
 */
export function isValidStatusFilter(parsed) {
    if (!Array.isArray(parsed)) return false;
    if (parsed.length === 0) return true;
    return parsed.every((k) => VALID_STATUS_KEYS.has(k));
}
